import i18n from 'i18next';
import {
  useNavigate,
} from 'react-router';

import {
  getEntityPath,
} from 'web-utils';

import {
  Button,
} from 'web-components';

import {
  SVG,
  Flex,
} from 'web-styled';

import * as S from './styled';

type Item = {
  id: number,
  name: string,
  is_root: boolean,
  basePath: string,
};

type Props = {
  items: Item[],
  basePath: string,
  hideBackChevron?: boolean,
  backPath?: string,
  parentId?: number | null,
  entityFolderId?: number,
  onChangeLastItem?: { (name: string): void },
};

const Breadcrumbs = ({
  items,
  basePath,
  backPath,
  parentId,
  entityFolderId,
  hideBackChevron,
  onChangeLastItem,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Flex
      align="center"
      spacing={10}
    >
      {
        !hideBackChevron && (
          <Flex width="15px">
            <Button
              icon={<SVG.ChevronLeft size={16} strokeWidth={3} />}
              appearance="link"
              onClick={() => {
                if (backPath && entityFolderId) {
                  navigate(`${backPath}/${entityFolderId}`);
                } else if (backPath && parentId) {
                  navigate(`${backPath}/${parentId}`);
                } else {
                  navigate(-1);
                }
              }}
              noPrint
            />
          </Flex>
        )
      }
      <Flex wrap="wrap" spacing={10} align="center">
        {items.map((item, i) => {
          const isLast = i > 0 && i === items.length - 1;
          if (isLast && onChangeLastItem) {
            return (
              <S.EditableItem
                key={item.id}
                html={item.name}
                onChange={() => { }}
                onBlur={(e: any) => {
                  onChangeLastItem(e.target.textContent || '');
                }}
                onKeyDown={(e: any) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    const div = e.target as HTMLElement;
                    onChangeLastItem(div.textContent || '');
                  }
                }}
              />
            );
          }

          return (
            <Flex align="center" key={item.id} spacing={10}>
              {i !== 0 && <SVG.ChevronRight size={13} />}
              <S.Item
                to={getEntityPath(item, item.basePath || basePath)}
                selected={isLast}
              >
                {item.is_root ? i18n.t(item.name) : item.name}
              </S.Item>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default Breadcrumbs;
